/**
 * Centralized smooth scroll utility
 * Provides consistent smooth scrolling behavior across the application
 */

export const smoothScrollTo = (elementId) => {
  const element = document.querySelector(`#${elementId}`);
  if (!element) {
    console.warn(`Element with id "${elementId}" not found`);
    return;
  }

  const targetPosition = element.offsetTop - 100;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 1800;
  let start = null;

  function animation(currentTime) {
    if (start === null) start = currentTime;
    const timeElapsed = currentTime - start;
    const progress = Math.min(timeElapsed / duration, 1);

    // Ease in-out quart function for smooth animation
    const easeInOutQuart = progress < 0.5
      ? 8 * progress * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 4) / 2;

    window.scrollTo(0, startPosition + distance * easeInOutQuart);

    if (progress < 1) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
};

/**
 * Scroll to element with custom offset
 */
export const smoothScrollToWithOffset = (elementId, offset = 100) => {
  const element = document.querySelector(`#${elementId}`);
  if (!element) {
    console.warn(`Element with id "${elementId}" not found`);
    return;
  }

  const targetPosition = element.offsetTop - offset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 1800;
  let start = null;

  function animation(currentTime) {
    if (start === null) start = currentTime;
    const timeElapsed = currentTime - start;
    const progress = Math.min(timeElapsed / duration, 1);

    const easeInOutQuart = progress < 0.5
      ? 8 * progress * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 4) / 2;

    window.scrollTo(0, startPosition + distance * easeInOutQuart);

    if (progress < 1) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
};
